import LocomotiveScroll from "locomotive-scroll";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import each from "lodash/each";
import { copyText } from "./utils/index";
// import Home from "./pages/home";

const toContactButtons = document.querySelectorAll(".contact-scroll");
const footer = document.getElementById("js-footer");
const scrollEl = document.querySelector("[data-scroll-container]");
const emailButton = document.querySelector("button.email");
const toCopyText = document.querySelector(".to-copy span");
// const body = document.body;

gsap.registerPlugin(ScrollTrigger);

const scroll = new LocomotiveScroll({
  el: scrollEl,
  smooth: true,
  lerp: 0.06,
  tablet: {
    breakpoint: 768,
  },
});

setTimeout(() => {
  scroll.update();
}, 1000);

scroll.on("scroll", ScrollTrigger.update);

ScrollTrigger.scrollerProxy(scroll.el, {
  scrollTop(value) {
    return arguments.length
      ? scroll.scrollTo(value, 0, 0)
      : scroll.scroll.instance.scroll.y;
  },

  getBoundingClientRect() {
    return {
      top: 0,
      left: 0,
      width: window.innerWidth,
      height: window.innerHeight,
    };
  },
});

export default class Home {
  constructor(scroll) {
    this.locomotive = scroll;
    this.heroTextAnimation();
    this.homeIntro();
    this.homeAnimations();
    this.homeActions();
  }

  homeActions() {
    each(toContactButtons, (button) => {
      button.onclick = () => {
        this.locomotive.scrollTo(footer);
      };
    });

    emailButton.addEventListener("click", (e) => {
      copyText(e);
      toCopyText.textContent = "copied";

      setTimeout(() => {
        toCopyText.textContent = "Click To Copy";
      }, 2000);
    });
  }

  homeIntro() {
    const tl = gsap.timeline();

    gsap.to(scrollEl, {
      autoAlpha: 1,
    });

    tl.from(".home__nav", {
      duration: 0.5,
      delay: 0.3,
      opacity: 0,
      yPercent: -100,
      ease: "power4.out",
    })
      .from(".hero__title [title-overflow]", {
        duration: 0.7,
        yPercent: 100,
        stagger: {
          amount: 0.2,
        },
        ease: "power4.out",
      })
      .from(
        ".hero__title .bottom__right",
        {
          duration: 1,
          yPercent: 100,
          opacity: 0,
          ease: "power4.out",
        },
        "<20%"
      )
      .set(".hero__title .overflow", { overflow: "unset" })
      .from(
        ".hero__title .mobile",
        {
          duration: 0.7,
          yPercent: 100,
          stagger: {
            amount: 0.2,
          },
          ease: "power4.out",
        },
        "-=1.4"
      );
      tl.to(".welcome", {
        duration: 0.8,
        delay: 0.3,
        opacity: 1,
        stagger: {
          amount: 0.2,
        },
        y: 0,
        ease: "power4.out",
      })
      tl.to(".home__hero__top__left .head-one", {
        duration: 1,
        delay: 0.2,
        opacity: 1,
        stagger: {
          amount: 0.2,
        },
        y: 0,
        ease: "power4.out",
      })
      tl.to(".home__hero__top__left .head-two", {
        duration: 0.8,
        delay: 0.2,
        opacity: 1,
        stagger: {
          amount: 0.2,
        },
        y: 0,
        ease: "power4.out",
      })
      tl.to(".home__hero__top__left .head-third", {
        duration: 0.5,
        delay: 0.2,
        opacity: 1,
        stagger: {
          amount: 0.2,
        },
        y: 0,
        ease: "power4.out",
      })
      tl.to("#value", {
        duration: 0.5,
        delay: 0.2,
        opacity: 1,
        stagger: {
          amount: 0.2,
        },
        y: 0,
        ease: "power4.out",
      })
        tl.to("#excel", {
        duration: 0.5,
        delay: 2.2,
        opacity: 0.8,
      
        ease: "power4.out",
      })
      tl.to("#inter", {
        duration: 0.5,
        delay: 2.4,
        margin:"10% -1%" ,
        opacity: 0.9,
      
        ease: "power4.out",
      })
       tl.to("#customer-s", {
        duration: 0.9,
        delay: 2.6,
        opacity: 0.8,
      
        ease: "power4.out",
      })
      tl.to(".home__hero .hero__paragraph", {
        duration: 0.5,
        delay: -1.9,
        opacity: 1,
        stagger: {
          amount: 0.2,
        },
        y: 0,
        ease: "power4.out",
      })
  }

  homeAnimations() {
    gsap.to(".home__projects__line", { autoAlpha: 1 });
    gsap.utils.toArray(".home__projects__line").forEach((el) => {
      const line = el.querySelector("span");
      gsap.from(line, {
        duration: 1.5,
        scrollTrigger: {
          trigger: el,
          scroller: "[data-scroll-container]",
        },
        scaleX: 0,
      });
    });

    gsap.utils.toArray("[data-fade-in]").forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          trigger: el,
          scroller: "[data-scroll-container]",
        },
        duration: 1.5,
        yPercent: 100,
        opacity: 0,
        ease: "power4.out",
      });
    });

    if (window.innerWidth <= 768) {
      gsap.utils.toArray(".home__projects__project").forEach((el) => {
        const text = el.querySelector(".title__main");
        const link = el.querySelector(".project__link");
        gsap.from([text, link], {
          scrollTrigger: {
            trigger: el,
            scroller: "[data-scroll-container]",
          },
          duration: 1.5,
          yPercent: 100,
          stagger: {
            amount: 0.2,
          },
          ease: "power4.out",
        });
      });

 
    }
  }

  heroTextAnimation() {
    gsap.to(".hero__title__dash.desktop", {
      scrollTrigger: {
        trigger: ".hero__title",
        scroller: "[data-scroll-container]",
        scrub: true,
        start: "-8% 9%",
        end: "110% 20%",
      },
      scaleX: 2,
      ease: "none",
    });
  }
}

new Home(scroll);
